import React from "react"
import { combineReducers } from "redux"
import app from "./reducers/index"

export default combineReducers({ app })
